<section>
  <header>
    <h2 class="heading-underline">Debugger</h2>
  </header>

  <h3 class="expandable" (click)="hideSelectedXml = !hideSelectedXml">
    Selected XML
  </h3>
  <pre lang="xml" [hidden]="hideSelectedXml">
  {{ documentXml | async }}
  </pre>

  <h3 class="expandable" (click)="hideTreeSummary = !hideTreeSummary">
    Docx4J Tree Summary
  </h3>
  <pre class="no-white-space" [hidden]="hideTreeSummary">
  {{ treeSummary | async }}
  </pre>

  <h3 class="expandable" (click)="hideContentControls = !hideContentControls">
    Content Controls
  </h3>
  <pre [hidden]="hideContentControls">
    {{ contentControls | async | json }}
  </pre>
</section>
